import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import style from "./NewPassword.module.scss";
import Input from "../../../input/signInput/input"
import Button from "../../../Button/button"
import toEnglishNumber from "../../../../helpers/actions/toEnglishNumber";
import toPersianNumber from "../../../../helpers/actions/toPersianNumber"
import { ResetPassword } from "../../../../actions/APIcalls"

const NewPassword = (props) => {

    const [newPassword, setNewPassword] = useState('')
    const [loading, setLoading] = useState(false);
    const [rememberPassword, setRememberPassword] = useState(false)

    const handleBlure = () => {
        /**/
    }

    const recoverAcount = async () => {
        // todo move to api calls
        if (typeof props.location.state != 'undefined' && props.location.state.phone && props.location.state.code) {
            let params = {
                phone: props.location.state.phone,
                password: toEnglishNumber(newPassword),
                code: props.location.state.code
            }
            setLoading(true)
            let res = await ResetPassword(params)
            if (typeof res !== "undefined") {
                if (res.data.success) {
                    props.history.push('/')
                    setLoading(false)
                }
            } else {
                setLoading(false)
            }
        }
    }

    const handleForm = (tag, e) => {
        if (tag === 'newpassword') {
            let temp = e.target.value
            setNewPassword((temp))
        }
    }
    return (
        <React.Fragment>
            <div className={style.signUpStepOne}>
                {/* <p className={style.signinLinkText}>حساب‌کاربری ندارید؟<span><Link
                    to='/signup/stepone'>ثبت‌نام</Link></span></p> */}

                <div className={style.stepOneFrame}>
                    <h3>بازیابی رمز عبور</h3>
                    <div className={style.stepOneFormFrame}>
                        <p className={style.requesting}>لطفا رمز عبور جدید خود را وارد کنید.</p>

                        <div className={style.inputWrapper}>
                            <Input
                                type="password"
                                disabled={false}
                                label="رمز عبور"
                                placeholder="رمز عبور جدید"
                                tag="newpassword"
                                value={toPersianNumber(newPassword)}
                                error=''
                                tooltip=''
                                onchange={handleForm}
                                onblur={handleBlure}
                            />
                        </div>
                        <div
                            onClick={() => setRememberPassword(!rememberPassword)}
                            className={style.forgotPasswordWrapper}
                        >
                            <input className={rememberPassword ? style.inputChecked : style.inputCheckboxClass}
                                type='checkbox'></input>
                            <p>به‌خاطر سپردن اطلاعات ورود</p>
                        </div>
                    </div>
                    <div className={style.buttonWrapper}>
                        <Button
                            loading={loading}
                            disabled={false}
                            tag="recover"
                            type="solid"
                            label="تایید و ورود"
                            onclick={recoverAcount}
                        />
                        <p className={style.registerLink}>حساب‌کاربری ندارید؟
                            <span className={style.link}>
                                <Link
                                    to='/signup/stepone'>ثبت‌نام در موبیشا</Link>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(NewPassword);